import {Button} from "antd";
import {PreventiveDialog} from "./PreventiveDialog";
import {PracticeType} from "../../../../../models/Practice/Practice";
import {useModal} from "../../../../../utils/modals";
import {PracticeDetail, UploadEstimateBodyRequest} from "../../../../../models/Practice/PracticeDetail";

export interface PreventiveDialogTriggerProps {
    practiceDetail?: PracticeDetail;
    disabled?: boolean;
    isLoaded: boolean;
    onSubmit: (body: UploadEstimateBodyRequest) => Promise<void>;
    agreement: PracticeType;
    integrationCode:string
    insuranceProviderId:number,
    locationCode: string;
}

export function PreventiveDialogTrigger(props: PreventiveDialogTriggerProps) {

    const agreement = (props.practiceDetail) ? props.practiceDetail.agreement : props.agreement;
    const locationCode =  (props.practiceDetail) ? props.practiceDetail.shopName : props.locationCode;

    const {
        isOpen,
        open,
        close
    } = useModal()

    const openModal = () => {
        if (!props.isLoaded) {
            open();
        }
    }

    const onSubmit = async (body: UploadEstimateBodyRequest) => {
        await props.onSubmit(body);
        close();
    }

    const onCancel = () => {
        close();
    }

    return <>
        <Button disabled={props.disabled} type={"primary"} className={!props.disabled && props.isLoaded ? "luxottica-button-success" : ""} onClick={openModal}>Preventivo</Button>
        <PreventiveDialog isModalOpen={isOpen} onSubmit={onSubmit} onCancel={onCancel}
                          agreement={agreement}
                          integrationCode={props.integrationCode}
                          insuranceProviderId={props.insuranceProviderId}
                          locationCode={locationCode}
                          practiceDetail={props.practiceDetail}
        />
    </>
}